import PropTypes from 'prop-types'
import React from 'react'

import {
  TextFieldInput,
  MaskedInputStyled,
  TextFieldWrapper,
  Underline,
  TextFieldPlaceholder,
  TextFieldError,
} from './styles'

const TextFieldInner = props => {
  const {
    meta: { dirtySinceLastSubmit, touched, error, submitFailed },
    input: inputOptions,
    placeholder,
    mask,
    maskPlaceholder,
    withoutErrorIndent,
    submitErrors,
    forceSubmitError,
    isDisabled,
    ...inputProps
  } = props
  const submitError =
    !dirtySinceLastSubmit && submitErrors
      ? submitErrors.find(error => error.field === inputOptions.name)
      : {}
  const needToShowError =
    !!((touched || submitFailed) && error !== undefined) ||
    !!(submitError && submitError.field)

  const isWithDefaultValue = !!inputOptions.value
  const submitErrorMessage =
    submitError && submitError.field
      ? forceSubmitError || submitError.message
      : null
  const errorMessage = error || submitErrorMessage

  const onChangeHandler = React.useCallback(
    e => {
      inputOptions.onChange(e)
      inputProps.onChange?.(e)
    },
    [inputOptions, inputProps],
  )

  const onFocusHandler = React.useCallback(
    e => {
      inputOptions.onFocus(e)
      inputProps.onFocus?.(e, inputOptions)
    },
    [inputOptions, inputProps],
  )

  const onBlurHandler = React.useCallback(
    e => {
      inputProps.onBlur?.(e, inputOptions)
      inputOptions.onBlur(e)
    },
    [inputOptions, inputProps],
  )

  const inputChildren = React.useMemo(() => {
    // Если форма ввода использует маску
    if (mask) {
      const modifyMask = (prev, element) =>
        element instanceof RegExp ? `${prev}x` : `${prev}${element}`
      const smartPlaceholder =
        maskPlaceholder || maskPlaceholder === ''
          ? maskPlaceholder
          : mask.reduce(modifyMask, '')

      return (
        <MaskedInputStyled
          guide={false}
          mask={mask}
          placeholder={smartPlaceholder}
          {...inputOptions}
          {...inputProps}
          disabled={isDisabled}
          onBlur={onBlurHandler}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
        />
      )
    } else {
      return (
        <TextFieldInput
          disabled={isDisabled}
          {...inputOptions}
          {...inputProps}
          onBlur={onBlurHandler}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
        />
      )
    }
  }, [
    mask,
    maskPlaceholder,
    inputOptions,
    inputProps,
    isDisabled,
    onBlurHandler,
    onChangeHandler,
    onFocusHandler,
  ])

  return (
    <TextFieldWrapper
      withoutError={withoutErrorIndent}
      isWithDefaultValue={isWithDefaultValue}
      isError={needToShowError}
      withMask={mask && maskPlaceholder !== ''}
      data-has-value={isWithDefaultValue}
      data-has-mask={!!(mask && maskPlaceholder !== '')}
      data-has-error={needToShowError}
    >
      {inputChildren}

      {placeholder ? (
        <TextFieldPlaceholder
          dangerouslySetInnerHTML={{ __html: placeholder }}
        />
      ) : null}

      <Underline />

      {needToShowError ? (
        <TextFieldError dangerouslySetInnerHTML={{ __html: errorMessage }} />
      ) : null}
    </TextFieldWrapper>
  )
}

TextFieldInner.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  withoutErrorIndent: PropTypes.bool.isRequired,
  forceSubmitError: PropTypes.string,
  submitErrors: PropTypes.any,
  isDisabled: PropTypes.bool,
  mask: PropTypes.array,
  maskPlaceholder: PropTypes.string,
  placeholder: PropTypes.string,
}

TextFieldInner.defaultProps = {
  isDisabled: false,
}

export default TextFieldInner
